import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const revealOnScroll = (element: Element | null, options = {}) => {
  if (!element) return;
  
  return gsap.from(element, {
    y: 50,
    opacity: 0,
    duration: 1,
    ease: 'power3.out',
    scrollTrigger: {
      trigger: element,
      start: 'top 85%',
      toggleActions: 'play none none reverse',
      ...options
    }
  });
};

export const staggerRevealOnScroll = (container: Element | null, childrenSelector: string, options = {}) => {
  if (!container) return;
  
  const children = container.querySelectorAll(childrenSelector);
  
  return gsap.from(children, {
    y: 40,
    opacity: 0,
    duration: 0.8,
    stagger: 0.1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: container,
      start: 'top 80%',
      toggleActions: 'play none none reverse',
      ...options
    }
  });
};
